import { TransactionSuccessToast } from "@/components";
import type { TransactionHash } from "@/types";

interface CancelExitSuccessToastProps {
    transactionHash: TransactionHash;
    newUnwindingEpochs: number;
    onClose?: () => void;
}

export function CancelExitSuccessToast({ transactionHash, newUnwindingEpochs, onClose }: CancelExitSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Cancel successful" transactionHash={transactionHash} onClose={onClose}>
            <div className="text-gray-400">Duration</div>
            <div className="text-white">{newUnwindingEpochs} weeks</div>
        </TransactionSuccessToast>
    );
}
